/** PIN rules are shared by the browser and replay verifier. */
export const PIN = {
  length: 4,
} as const;

/** Render-only feedback; excluded from the replay fingerprint and run timer. */
export const PIN_FEEDBACK = {
  errorSeconds: 1,
  blinkSeconds: 0.25,
  successSeconds: 0.5,
} as const;

/** Keyboard targets move independently of the camera comfort setting. */
export const PIN_VIEW = {
  alcoholScale: 5,
  alcoholGain: 4,
  drugScale: 100,
  maxX: 6,
  maxY: 9,
  maxRotation: 5,
} as const;
